const faqs = [
  {
    q: '海角网有哪些主要内容板块？',
    a: '海角网主要包含海角视频、海角社区和海角论坛三大核心板块。视频区汇聚海量原创视频资源，社区提供互动交流空间，论坛支持深度话题讨论。此外还有海角社专题策划和各类主题索引，满足不同用户的浏览需求。',
  },
  {
    q: '如何找到海角网的最新官网入口？',
    a: '海角网官网入口保持稳定更新，你可以通过海角网址导航直接访问。建议将海角官网加入收藏夹，或关注海角社区网站的官方公告获取最新地址信息。海角在线服务全天候可用，确保用户随时访问。',
  },
  {
    q: '海角网免费看的内容有哪些？',
    a: '海角网免费看覆盖视频、图文、讨论帖等多元化内容，平台每日更新大量免费原创资源。海角社区成员可以自由浏览、互动和分享，部分精品专题和特色内容也向所有访客开放，无需付费即可享受丰富的社区体验。',
  },
  {
    q: '如何加入海角社参与创作和讨论？',
    a: '加入海角社非常简单，通过海角网站入口注册账号即可成为社区成员。注册后你可以发布原创作品、参与论坛讨论、收藏感兴趣的内容，与海角网千万原创创作者一起交流互动。平台对新人友好，设有完善的引导机制。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            快速了解海角网的使用方式
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              open={i === 0}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-foreground-400">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}